/**
 * @file
 * Table of contents behaviors for layerone.
 *
 * Requires global.js to be loaded first (Drupal.layerone.getScreenWidth).
 */
(function ($, Drupal) {

  'use strict';

  Drupal.behaviors.layeroneTableOfContents = {
    attach: function (context, settings) {

      // Table of contents
      // Bootsrap dynamic TOC in page navigation
      $('.field--name-field-components h2', context).addClass('toc-heading2');

      let toc = $('#table-of-contents', context);
      if (toc.length > 0) {
        $('#table-of-contents', context).dynamicContentMenu({
          'selectors': '.toc-heading2',
          smoothScrollSpeed: 'slow',
          smoothScroll: true,
          theme: 'bootstrap',
          hideEffect: 'none',
          extendPage: false,
          scrollTo: 200,
        });
      }

      // inject blank href for keyboard accessibility in TOC links
      $('.dynamicContentMenu__item a').each(function(){
        $(this).attr('href', '#');
      });

      // Move table of contents on larger screen sizes
      function moveTableOfContents() {
        let screenWidth = Drupal.layerone.getScreenWidth();
        let $toc = $(document.getElementById('table-of-contents-content'));
        if ($('#table-of-contents', context).length > 0) {
          if ($('.node--type-standard', context).length > 0) {
            if (screenWidth < 992) {
              if ($('#table-of-contents-container', context).find('#table-of-contents-content').length === 0) {
                $toc.appendTo('#table-of-contents-container');
              }
              $('.node--content-page--full', context).css('max-width', '700px');
              $('#table-of-contents-large-container', context).css('min-width', '500px');
            } else if (screenWidth < 1200) {
              if ($('#table-of-contents-large-container', context).find('#table-of-contents-content').length === 0) {
                $toc.appendTo('#table-of-contents-large-container');
              }
              $('.node--content-page--full', context).css('max-width', '600px');
              $('#table-of-contents-large-container', context).css('min-width', '300px');
            } else {
              if ($('#table-of-contents-large-container', context).find('#table-of-contents-content').length === 0) {
                $toc.appendTo('#table-of-contents-large-container');
              }
              $('.node--content-page--full', context).css('max-width', '700px');
              $('#table-of-contents-large-container', context).css('min-width', '380px');
            }
          }
          else if ($('.node--type-content-page', context).length > 0) {
            // Content pages
              if (screenWidth < 992) {
                if ($('#table-of-contents-container', context).find('#table-of-contents-content').length === 0) {
                  $toc.appendTo('#table-of-contents-container');
                }
                $('.node--content-page--full', context).css('max-width', '840px');
                $('#table-of-contents-large-container', context).css('min-width', '0');
              } else if (screenWidth < 1200) {
                if ($('#table-of-contents-large-container', context).find('#table-of-contents-content').length === 0) {
                  $toc.appendTo('#table-of-contents-large-container');
                }
                $('.node--content-page--full', context).css('max-width', '70%');
                $('#table-of-contents-large-container', context).css('min-width', '29%');
              } else if (screenWidth < 1400) {
                if ($('#table-of-contents-large-container', context).find('#table-of-contents-content').length === 0) {
                  $toc.appendTo('#table-of-contents-large-container');
                }
                $('.node--content-page--full', context).css('max-width', '70%');
                $('#table-of-contents-large-container', context).css('min-width', '23%');
              } else {
                if ($('#table-of-contents-large-container', context).find('#table-of-contents-content').length === 0) {
                  $toc.appendTo('#table-of-contents-large-container');
                }
                $('.node--content-page--full', context).css('max-width', '70%');
                $('#table-of-contents-large-container', context).css('min-width', '22%');
              }
          }
          else {
            let screenWidth = window.innerWidth;
            let $toc = $(document.getElementById('table-of-contents-content'));
          }
        }


      }

      let largeContainer = $('#table-of-contents-large-container', context).text();
      if (largeContainer  === 'TOC') {
        $('#table-of-contents-large-container', context).text('');
      }

      moveTableOfContents();

      window.addEventListener('resize', function(){
        moveTableOfContents();
      },true);

    }
  };

})(jQuery, Drupal);
